import { ChipProps, useTheme } from "@mui/material";
import BarekamText from "../text";
import React from "react";
import { BarekamChipContainer } from "./styled";
import { Message, MessageSections } from "../message/message";

const BarekamChip = (props: BarekamChipProps) => {
  const { messageKey, message, statusId, chipSize, messageSection, styles } =
    props;
  const theme = useTheme();

  const statusColors = new Map<number, string>([
    [1, theme.barekam.filter.chips.colors.yellow],
    [2, theme.barekam.filter.chips.colors.green],
    [3, theme.barekam.filter.chips.colors.blue],
    [4, theme.barekam.filter.chips.colors.red],
    [5, theme.barekam.filter.chips.colors.gray],
  ]);

  return (
    <BarekamChipContainer
      label={
        <BarekamText variant={chipSize === "s" ? "xs" : "s"}>
          {messageKey ? (
            <Message
              messageKey={messageKey}
              sectionId={
                messageSection ? messageSection : MessageSections.ORDERS
              }
            />
          ) : (
            message
          )}
        </BarekamText>
      }
      sx={{
        color: statusColors.get(statusId),
        backgroundColor: statusColors.get(statusId) + "30",
        ...styles,
      }}
    />
  );
};

export default BarekamChip;

interface BarekamChipProps extends ChipProps {
  messageKey?: string;
  message?: string;
  messageSection?: MessageSections;
  styles?: Record<string, string>;
  statusId: number;
  chipSize: "s" | "l";
}
